<template>
  <div style="display: inline-block">
    <v-btn color="primary" @click="openModal" outline>
      <i class="fas fa-exchange-alt mr-1"></i>
      {{ $t('Transfer') }}
    </v-btn>
    <v-dialog v-model="showTransfer" scrollable max-width="1000px">
      <v-card>
        <v-premium-plan-popup
          text="waste_time_setting_up_template_on_a_new_page_just_select_the_page_and_press_transfer"
          :showAll="false"
          marginTop="65"
          v-if="$store.getters.getPackage != 'premium'"
        ></v-premium-plan-popup>
        <v-card-title>
          <v-layout wrap row class="mb-0">
            <v-flex xs12 sm5 class="text-xs-center">
              <v-menu offset-y open-on-hover offset-overflow max-height="200" :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-btn outline round color="primary" v-on="on">
                    <template v-if="currentPage">
                      <div
                        class="text-truncate"
                        style="display:inline-block; word-break: break-all;max-width: 150px;    vertical-align: middle;"
                      >
                        {{ currentPage.name }}
                      </div>
                    </template>
                    <template v-else>{{ $t('Select page') }}</template>
                  </v-btn>
                </template>
                <v-card>
                <div class="form-control pa-1">
                  <input
                    type="text"
                    v-model="searchOptionBotlist"
                    class="mb-0"
                    :placeholder="$t('Search')"
                  />
                </div>
                <v-list>
                  <v-list-tile
                    v-for="(item, index) in optionBotlist"
                    :key="index"
                    @click="selectBot(item)"
                  >
                    <v-list-tile-title class="primary-color">{{ item.name }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
                </v-card>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm2 class="text-xs-center">
              <i class="fas fa-arrow-right hidden-xs-only mt-3"></i>
              <i class="fas fa-arrow-down hidden-sm-and-up mt-2"></i>
            </v-flex>

            <v-flex xs12 sm5 class="text-xs-center pt-3">
              <template
                v-if="
                  $aston.astonpages.includes(selectedBot.pageid) &&
                    $store.getters.getPackage == 'premium'
                "
              >
                <v-select
                  v-model="selectedBotlist"
                  :items="premiumBot"
                  single-line
                  multiple
                  outline
                  item-text="pagename"
                  item-value="pageid"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.pagename | truncate(20) }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ selectedBotlist.length - 1 }} others)</span
                    >
                  </template>
                </v-select>
              </template>
              <template v-else>
                {{ selectedBot.pagename }}
              </template>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;" class="pa-0">
          <div v-if="loading" class="spinner text-xs-center mt-2 mb-2">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
          <div class="text-xs-center mt-4 mb-4" v-else-if="comparelist.length == 0">
            {{ $t('Choose page to transfer') }}
          </div>
          <div class="pb-2" v-else>
            <v-layout style="background: #eee;">
              <v-flex>
                <v-list-tile>
                  <v-list-tile-action @click.prevent="toggleSelect(selectAll)">
                    <v-checkbox v-model="selectAll" color="primary"></v-checkbox>
                  </v-list-tile-action>

                  <v-list-tile-content
                    @click.prevent="
                      selectAll = !selectAll
                      toggleSelect(selectAll)
                    "
                  >
                    <v-list-tile-title>
                      {{ $t('Select All') }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-flex>
              <v-flex>
                <div class="form-control pa-1">
                  <input type="text" v-model="search" class="mb-0" :placeholder="$t('Search')" />
                </div>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>

            <template v-for="(compare, index) in filterComparelist">
              <v-list-tile :key="'compare_' + compare.id">
                <v-list-tile-action>
                  <v-checkbox v-model="compare.selected" color="primary"></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click.prevent="compare.selected = !compare.selected">
                  <v-list-tile-title>
                    <template v-if="compare.message_name == '{default}'">
                      {{ $t('Default Conversation') }}
                    </template>
                    <template v-else-if="compare.message_name == '{default_comment_to_inbox}'">
                      {{ $t('More Comment to Inbox') }}
                    </template>
                    <template v-else-if="compare.message_name == '{welcome}'">
                      {{ $t('Welcome Message') }}
                    </template>
                    <template v-else>{{ compare.message_name }}</template>
                  </v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action
                  class="text-xs-center"
                  @click.prevent="compare.selected = !compare.selected"
                >
                  <v-list-tile-action-text v-if="!compare.is_duplicated_message_name" style="margin: auto;">
                    {{ $t('Insert2') }}
                  </v-list-tile-action-text>
                  <v-list-tile-action-text v-else style="margin: auto;" class="info--text">
                    {{ $t('replace_template') }}
                  </v-list-tile-action-text>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider
                v-if="index + 1 < filterComparelist.length"
                :key="index"
                class="mt-2"
              ></v-divider>
            </template>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout wrap>
            <v-flex
              xs12
              sm8
              class="px-2 py-2"
              :class="{
                'red--text':
                  (totalIntent > maxintent &&
                    selectedBot.pagetype != 'enterprise' &&
                    $store.getters.getPackage != 'premium') ||
                  (totalIntent > max_custom_intent && selectedBot.pagetype != 'enterprise')
              }"
            >
              {{ $t('Current items') }} {{ currentIntent }} <span shrink class="px-2">+</span>
              {{ $t('New items') }} {{ newIntent }} <span shrink class="px-2">=</span>
              {{ totalIntent }}
            </v-flex>
            <v-flex xs12 sm4>
              <div class="text-xs-left text-sm-right py-2 pr-3 pl-2">
                <template
                  v-if="
                    selectedBot.pagetype != 'enterprise' && $store.getters.getPackage != 'premium'
                  "
                  >{{ $t('Maximum') }} {{ maxintent }}</template
                >
                <template v-else-if="selectedBot.pagetype != 'enterprise'"
                  >{{ $t('Maximum') }} {{ max_custom_intent }}</template
                >
                <template v-else>{{ $t('Unlimit') }}</template>
              </div>
            </v-flex>
          </v-layout>

          <div class="text-xs-right">
            <v-btn outline color="grey" @click="showTransfer = false">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" :loading="loading" :disabled="isSelected == 0" @click="saveTransfer">
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalDialog from '@/components/elements/ModalDialog'
import api from '@/api'
import axios from 'axios'
import config from '@/config'
import dayjs from 'dayjs'
export default {
  props: ['type', 'intents', 'total_count', 'all_count'],
  data: () => {
    return {
      showTransfer: false,
      currentPage: null,
      loading: false,
      searchOptionBotlist: '',
      
      comparelist: [],
      selectAll: false,
      search: '',
      maxintent: 10,
      selectedBotlist: [],
      max_custom_intent: 1
    }
  },
  components: {
    ModalDialog
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),
    premiumBot() {
      return this.botlist.filter(el => {
        const now = dayjs()
        const date = dayjs(el.expireat)
        const expriedTime = parseInt(date.diff(now, 'seconds'))

        return expriedTime > 0
      })
    },
    optionBotlist: function() {
      let options = []
      const vm = this
      try {
        if (vm.botlist) {
          options = vm.botlist
            .filter(val => {
              return val.pageid != vm.selectedBot.pageid
            })
            .map(val => {
              return { name: val.pagename, value: val.pageid }
            })
        }
      } catch (error) {
        console.log('error', error)
      }

      if (!this.searchOptionBotlist || this.searchOptionBotlist == '') {
        return options
      }

      return options.filter(el => {
        return el.name.toLowerCase().includes(this.searchOptionBotlist.toLowerCase())
      })
    },
    isSelected: function() {
      return this.comparelist.filter(function(el) {
        return el.selected
      }).length
    },
    filterComparelist() {
      if (!this.search || this.search == '') {
        return this.comparelist
      }

      return this.comparelist.filter(el => {
        return el.message_name.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    totalIntent() {
      return this.all_count + this.newIntent
    },
    currentIntent() {
      const vm = this
      return vm.all_count
    },
    newIntent() {
      const insertlist = this.comparelist.filter(el => {
        return el.selected && el.is_duplicated_message_name == false
      })
      return insertlist.length
    }
  },
  async mounted() {
    const vm = this
    let package_config = vm.getPackageConfig()
    vm.maxintent = package_config.adsSimulator
        // ถ้า custom แล้วอันใดอันนึงไม่เท่ากัน
    if (vm.maxintent > vm.max_custom_intent) vm.max_custom_intent = vm.maxintent
    else if (vm.maxintent < vm.max_custom_intent) vm.maxintent = vm.max_custom_intent
  },
  methods: {
    getIntent: function() {
      const vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getIntent(data, function(error, response) {
          if (error) {
            reject(error)
            return
          }
          if (response.data) {
            resolve(response.data)
          } else reject()
        })
      })
    },
    openModal: function() {
      const vm = this
      vm.showTransfer = true
    },
    selectBot(page) {
      const vm = this
      vm.currentPage = page
      vm.loading = true
      vm.getCompareIntents(vm.currentPage).then(()=>{
        vm.loading = false
      }).catch((error)=>{
        vm.loading = false
        console.error(error);
      })
    },
    onSave(intentsid){
      const vm = this
      vm.loading = true
      let url = config.serverUrl + 'page/' + vm.selectedBot.pageid + '/clone-messenger-ads-simulator'
      axios.post(url,{ "from_page_id": this.currentPage.value, "ids": intentsid })
      .then(response => {
        if (response.data && response.data.success) {
          vm.showTransfer = false
          // vm.$store.dispatch('loading')
          vm.$swal
            .fire({
              title: vm.$t('Successfully'),
              text: vm.$t('transfer_template_messenger_ads'),
              type: 'success',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
            .then(function(result) {
              if (result.value) {
                location.reload()
              }
            })
        }
      })
      .catch(e => {
        if (error) {
          vm.$store.dispatch('loading')
          vm.$swal.fire({
            title: vm.$t('Transfer template unsuccessful'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          return false
        }
      })
      .finally(()=>{
        vm.loading = false
        vm.showTransfer = false
      })
    },
    getCompareIntents: function(page) {
      const vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid1: page.value,
          pageid2: vm.selectedBot.pageid
        }
        api.getCompareAdsSimulator(data, function(error, response) {
          if (error) {
            reject(error)
          }
          vm.comparelist = []
          if (response) {
            response = response.sort(function(a, b) {
              let nameA = a.message_name.toLowerCase()
              let nameB = b.message_name.toLowerCase()
              if (a.message_name[0] === '{' && a.message_name[a.message_name.length - 1] === '}') {
                return 1
              }
              if (b.message_name[0] === '{' && b.message_name[b.message_name.length - 1] === '}') {
                return -1
              }
              if (nameA < nameB) {
                return -1
              }
              if (nameA > nameB) {
                return 1
              }
            })
            response.map(function(el) {
              let compare = el
              compare.selected = true
              vm.comparelist.push(compare)
            })
          }
          resolve()
        })
      })
    },
    saveTransfer: function() {
      const vm = this
      vm.$swal
        .fire({
          title: vm.$t('are_you_sure_you_want_to_transfer_the_template'),
          text: vm.$t('once_you_confirmed_you_cannot_go_back_and_the_existing_template_will_be_replaced'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            let intentsid = []

            if (vm.comparelist) {
              intentsid = vm.comparelist
                .filter(el => {
                  return el.selected
                })
                .map(function(el) {
                  return el.id
                })
            }

            if (
              vm.totalIntent > vm.maxintent &&
              vm.selectedBot.pagetype != 'enterprise' &&
              vm.$store.getters.getPackage != 'premium'
            ) {
              vm.$swal.fire({
                type: 'error',
                title: vm.$t(
                  'transferring_template_cannot_be_applied',
                  { size: vm.maxintent }
                ),
                footer: `<div class="text-xs-center"><a href="/${vm.$i18n.locale()}/upgrade">${vm.$t(
                  'If you wish to transfer, please click here to upgrade to premium package'
                )}</a></div>`
              })
              return false
            }

            if (
              vm.totalIntent > vm.max_custom_intent &&
              vm.selectedBot.pagetype != 'enterprise'
            ) {
              vm.$swal.fire({
                type: 'error',
                title: vm.$t(
                  'transferring_template_cannot_be_applied',
                  { size: vm.max_custom_intent }
                )
              })
              return false
            }

            if (intentsid.length == 0) {
              return false
            }

            let data = {
              pageid1: vm.currentPage.value,
              pageid2: vm.selectedBot.pageid,
              intentsid: intentsid.join(',')
            }

            if (
              vm.$aston.astonpages.includes(vm.selectedBot.pageid) &&
              vm.$store.getters.getPackage == 'premium'
            ) {
              data.pageid2 = vm.selectedBotlist.join(',')
            } else {
              data.pageid2 = vm.selectedBot.pageid
            }

            // vm.$store.dispatch('loading')
            vm.onSave(intentsid)
          }
        })
    },
    toggleSelect: function(value) {
      const vm = this
      if (vm.comparelist) {
        vm.comparelist.map(function(compare, index) {
          vm.comparelist[index].selected = value
        })
      }
    }
  },
  watch: {
    isSelected: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.selectAll = newVal == this.comparelist.length
      }
    },
    showTransfer: function(newVal, oldVal) {
      const vm = this
      if (newVal) {
        if (vm.currentPage != null) {
          vm.loading = true
          vm.getCompareIntents(vm.currentPage).then(()=>{
            vm.loading = false
          }).catch((error)=>{
            vm.loading = false
            console.error(error);
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/AdsSimulator/TransferJson.vue